import { GetListBankAccountParams } from '@/data/bank-account/types';
import { GetListContactParams } from '@/data/contact/types';
import { GetListCOASettingParams } from '@/data/coa-settings/types';
import { GetListContactGroupParams } from '@/data/contact/types';
import { GetListPSParams } from '@/data/product-service/types';
import { GetBusinessIndustriesParams } from '@/data/business/types';
import { GetGSTPeriodItemParams, GetListGSTParams, GetListGSTPeriodParams } from '@/data/gst/types';
import { GetBUByPeriod } from '@/data/bupu/types';
import { GetlistCOAParams } from '@/data/coa/types';
import { IGenerateMailPayload } from '@/modules/quote/types';
import { Invoice } from '@/services/InvoiceService/types';
import { IGenerateMailPayload as IInvoiceGenerateMailPayload } from '@/services/InvoiceService/types';
import { IGenerateMailPayload as IBillsToPayGenerateMailPayload } from '@/services/BillsToPayService/type';
import { IGenerateMailPayload as IPurchaseOrderGenerateMailPayload } from '@/services/PurchaseOrderService/types';

export const finacialKeys = {
  all: ['finacial'],
  periods: (accountNumberId: string, fnYear?: number | undefined) => [...finacialKeys.all, 'periods', accountNumberId, fnYear],
  // lists: () => [...finacialKeys.all, 'list'],
  // list: (filter: any) => [...finacialKeys.all, 'list', filter],

  // details: () => [...finacialKeys.all, 'detail'],
  // detail: (filter: any) => [...finacialKeys.all, 'detail', filter],
} as const;

export const businessKeys = {
  all: ['business'],
  lists: () => [...businessKeys.all, 'list'],
  list: (filter: any) => [...businessKeys.lists(), filter],
  selected: () => [...businessKeys.all, 'seleted'],
  // details: () => [...businessKeys.all, 'detail'],
  // detail: (filter: any) => [...businessKeys.details(), filter],

  abnList: () => [...businessKeys.all, 'abn-list'],
  abnLookup: (keyword: string) => [...businessKeys.all, 'abn-lookup', keyword],

  industryLists: () => [...businessKeys.all, 'industry-list'],
  industryList: (filter?: GetBusinessIndustriesParams) => [...businessKeys.all, 'industry-list', filter],
} as const;

export const bankKeys = {
  all: ['bank'],
  lists: () => [...bankKeys.all, 'list'],
  list: (filter: any) => [...businessKeys.lists(), filter],
};

export const bankAccountKeys = {
  all: ['bankAccount'],
  listsKey: () => [...bankAccountKeys.all, 'list'],

  lists: (businessId: string) => [...bankAccountKeys.listsKey(), businessId],
  list: (filter: GetListBankAccountParams) => [...bankAccountKeys.listsKey(), filter],
};

export const bankAccountNumberKeys = {
  all: ['bankAccountNumber'],
  selected: () => [...bankAccountKeys.all, ...bankAccountNumberKeys.all, 'selected'],
};

export const userKeys = {
  all: ['user'],

  profiles: () => [...userKeys.all, 'profiles'],
  profile: (filter: any) => [...userKeys.profiles(), filter],

  me: () => [...userKeys.all, 'me'],
} as const;

export const immutableKeys = {
  all: ['immutable'],

  selectBusiness: () => [...immutableKeys.all, 'select-business'],
  selectBusinessLeftMenu: () => [...immutableKeys.all, 'select-business-left-menu'],
};

export const contactKeys = {
  all: ['contact'],
  lists: () => [...contactKeys.all, 'list'],
  list: (filter: GetListContactParams) => [...contactKeys.lists(), filter],

  summaries: () => [...contactKeys.all, 'summary'],
  summary: (business: string) => [...contactKeys.all, 'summary', business],

  details: () => [...contactKeys.all, 'detail'],
  detail: (id: string) => [...contactKeys.details(), id],

  groupLists: () => [...contactKeys.all, 'list', 'group'],
  groupList: (filter: GetListContactGroupParams) => [...contactKeys.groupLists(), filter],
  groupDetails: () => [...contactKeys.all, 'group', 'detail'],
  groupDetail: (id: string) => [...contactKeys.groupDetails(), id],
} as const;

export const projectKeys = {
  all: ['project'],
  lists: () => [...projectKeys.all, 'list'],
  list: (filter: any) => [...projectKeys.lists(), filter],

  details: () => [...projectKeys.all, 'detail'],
  detail: (id: string) => [...projectKeys.details(), id],
};

export const psKeys = {
  all: ['product-service'],
  lists: () => [...psKeys.all, 'list'],
  list: (filter: GetListPSParams) => [...psKeys.lists(), filter],

  details: () => [...psKeys.all, 'detail'],
  detail: (id: string) => [...psKeys.details(), id],
} as const;

export const transactionKeys = {
  all: ['transaction'],
  lists: () => [...transactionKeys.all, 'list'],
  list: (filter: any) => [...transactionKeys.lists(), filter],

  // details: () => [...transactionKeys.all, 'detail'],
  // detail: (id: string) => [...transactionKeys.details(), id],
} as const;

export const coaKeys = {
  all: ['coa'],
  lists: (businessId: string) => [...coaKeys.all, 'list', businessId],
  list: (filter: { businessId: string; ids: string[] }) => [...coaKeys.lists(filter.businessId), filter],

  finds: () => [...coaKeys.all, 'find'],
  find: (businessID: string, params?: GetlistCOAParams) => [...coaKeys.finds(), businessID, params],
};

export const coaSettingKeys = {
  all: ['coa-settings'],
  lists: () => [...coaSettingKeys.all, 'list'],
  list: (filter: GetListCOASettingParams) => [...coaSettingKeys.lists(), filter],

  listInit: (filter: GetListCOASettingParams) => [...coaSettingKeys.lists(), 'init', filter],

  details: () => [...coaSettingKeys.all, 'detail'],
  detail: (id: string) => [...coaSettingKeys.details(), id],
};

export const bosbKeys = {
  all: ['bsob'],
  lists: (businessId: string) => [...bosbKeys.all, 'lists', businessId],
};

export const quoteKeys = {
  all: ['quote'],

  allList: () => [...quoteKeys.all, 'list'],
  lists: (filter: unknown) => [...quoteKeys.allList(), filter],

  detail: (id: string) => [...quoteKeys.all, 'detail', id],
  publicDetail: (payload: { id: string; email: string; key?: number }) => [...quoteKeys.all, 'public-detail', payload],

  statusCount: () => [...quoteKeys.all, 'status'],

  generateMail: (id: string, payload?: IGenerateMailPayload) => [...quoteKeys.all, 'generate-mail', id, payload],
};

export const billsToPayKeys = {
  all: ['billsToPay'],

  lists: () => [...billsToPayKeys.all, 'list'],
  list: (filter: unknown) => [...billsToPayKeys.lists(), filter],

  detail: (id: string) => [...billsToPayKeys.all, 'detail', id],
  publicDetail: (payload: { id: string; email: string; key?: number }) => [...billsToPayKeys.all, 'public-detail', payload],
  statusCount: (params?: { businessId?: string; contactId?: string }) => [...billsToPayKeys.lists(), 'status-count', params], // follow the list

  paymentByInvoice: (billID: string) => [...billsToPayKeys.all, 'payment-by-invoice', billID],
  generateMail: (id: string, payload?: IBillsToPayGenerateMailPayload) => [...billsToPayKeys.all, 'generate-mail', id, payload],
};

export const invoiceKeys = {
  all: ['invoice'],
  lists: () => [...invoiceKeys.all, 'list'],
  list: (filter: unknown) => [...invoiceKeys.lists(), filter],
  detail: (id: string) => [...invoiceKeys.all, 'detail', id],
  publicDetail: (payload: { id: string; email: string; key?: number }) => [...invoiceKeys.all, 'public-detail', payload],
  statusCount: (params?: Invoice.StatusCountParams) => [...invoiceKeys.lists(), 'status-count', params], // follow the list
  paymentByInvoice: (invoiceID: string) => [...invoiceKeys.all, 'payment-by-invoice', invoiceID],
  generateMail: (id: string, payload?: IInvoiceGenerateMailPayload) => [...invoiceKeys.all, 'generate-mail', id, payload],
};

export const purchaseOrderKeys = {
  all: ['purchaseOrder'],
  lists: () => [...purchaseOrderKeys.all, 'list'],
  list: (filter: unknown) => [...purchaseOrderKeys.all, filter],
  detail: (id: string) => [...purchaseOrderKeys.all, 'detail', id],
  publicDetail: (payload: { id: string; email: string; key?: number }) => [...purchaseOrderKeys.all, 'public-detail', payload],
  statusCount: () => [...purchaseOrderKeys.lists(), 'status-count'], // follow the list
  generateMail: (id: string, payload?: IPurchaseOrderGenerateMailPayload) => [...purchaseOrderKeys.all, 'generate-mail', id, payload],
};

export const gstKeys = {
  all: ['gst'],
  lists: () => [...gstKeys.all, 'list'],
  list: (filter?: GetListGSTParams) => [...gstKeys.lists(), filter],

  listPeriods: () => [...gstKeys.all, 'list-period'],
  listPeriod: (businessId: string, filter?: GetListGSTPeriodParams) => [...gstKeys.listPeriods(), businessId, filter],

  details: () => [...gstKeys.all, 'detail'],
  detail: (id: string) => [...gstKeys.details(), id],
  detailItem: (id: string, filter?: GetGSTPeriodItemParams) => [...gstKeys.detail(id), filter],
} as const;

export const bupuKeys = {
  all: ['bupu'],
  lists: () => [...bupuKeys.all, 'list'],

  listByPeriods: () => [...bupuKeys.all, 'list-by-period'],
  listByPeriod: (params: GetBUByPeriod) => [...bupuKeys.listByPeriods(), params],

  listPeriods: () => [...bupuKeys.all, 'list-period'],
  listPeriodByBusiness: (businessID: string) => [...bupuKeys.listPeriods(), businessID],
};

export const gjKeys = {
  all: ['gj'],
  lists: (businessId: string, filter: unknown) => [...gjKeys.all, 'lists', businessId, filter],
  detailLists: (gjDetail: string, filter: unknown) => [...gjKeys.all, 'detail-lists', gjDetail, filter],
};

export const accountNumberKeys = {
  all: ['account-number'],
  lists: (profileId: string, businessId: string) => [...accountNumberKeys.all, 'lists', profileId, businessId],
  listByBusinessId: (businessId: string) => [...accountNumberKeys.all, 'list-by-business-id', businessId],
  obCb: (accountNumberId: string, startDate: string) => [...accountNumberKeys.all, accountNumberId, 'obcb', startDate],
};

export const crunchSettingKeys = {
  all: ['crunch-setting'],
  listByAccounNumberAndDate: (accountNumberId: string, startDate: string) => [
    ...crunchSettingKeys.all,
    'listByAccounNumberAndDate',
    accountNumberId,
    startDate,
  ],
};

export const arKeys = {
  all: ['ar'],

  summaries: () => [...arKeys.all, 'summary'],
  summary: (filter: unknown) => [...arKeys.summaries(), filter],
} as const;
